import { render, staticRenderFns } from "./DetailCombo.vue?vue&type=template&id=7476d9f7&scoped=true&"
import script from "./DetailCombo.vue?vue&type=script&lang=js&"
export * from "./DetailCombo.vue?vue&type=script&lang=js&"
import style0 from "./DetailCombo.vue?vue&type=style&index=0&id=7476d9f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7476d9f7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VSimpleTable})
